import React, { useEffect, useState } from 'react';
import { puntosApi, asList, cardStyle, pillStyle, fmtDateTime } from './puntosApi';

const KINDS = [
    { id: '', label: 'Todos' },
    { id: 'earn', label: 'Compras' },
    { id: 'redeem', label: 'Canjes' },
    { id: 'adjustment', label: 'Ajustes' },
    { id: 'cancel', label: 'Anulaciones' },
];

const kindOf = (row) => {
    if (row.transaction_type === 'earn') return { label: 'Compra', background: '#e6f6ee', color: '#1f6b45' };
    if (row.transaction_type === 'redeem') return { label: 'Canje', background: 'var(--secondary-color)', color: 'var(--primary-color)' };
    if (row.transaction_type === 'expiration') return { label: 'Expiración', background: '#f3f4f6', color: '#4b5563' };
    if (row.order_reference) return { label: 'Anulación', background: '#fdecec', color: '#9b1c1c' };
    return { label: 'Ajuste', background: '#fdf3d8', color: '#8a6100' };
};

const toInputDate = (date) => date.toLocaleDateString('en-CA'); // YYYY-MM-DD en hora local

const daysAgo = (days) => {
    const date = new Date();
    date.setDate(date.getDate() - days);
    return toInputDate(date);
};

/** Todos los movimientos de puntos: compras, canjes, ajustes y anulaciones. */
const HistorialPuntos = () => {
    const [start, setStart] = useState(() => daysAgo(30));
    const [end, setEnd] = useState(() => toInputDate(new Date()));
    const [cedula, setCedula] = useState('');
    const [kind, setKind] = useState('');
    const [rows, setRows] = useState([]);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        let cancelled = false;
        const timer = setTimeout(async () => {
            setLoading(true);
            setError('');
            try {
                const res = await puntosApi.history({ start, end, cedula, kind });
                if (cancelled) return;
                const list = asList(res.data);
                setRows(list);
                setTotal(res.data?.count ?? list.length);
            } catch (err) {
                if (cancelled) return;
                console.error('[Puntos] Error cargando historial', err);
                setRows([]);
                setTotal(0);
                setError('No se pudo cargar el historial.');
            } finally {
                if (!cancelled) setLoading(false);
            }
        }, 300);
        return () => {
            cancelled = true;
            clearTimeout(timer);
        };
    }, [start, end, cedula, kind]);

    return (
        <div style={cardStyle}>
            <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'end', flexWrap: 'wrap', marginBottom: '1rem' }}>
                <div><label>Desde</label><input type="date" className="form-control" value={start} onChange={(e) => setStart(e.target.value)} /></div>
                <div><label>Hasta</label><input type="date" className="form-control" value={end} onChange={(e) => setEnd(e.target.value)} /></div>
                <div>
                    <label>Cédula</label>
                    <input className="form-control" inputMode="numeric" placeholder="Todas" value={cedula} onChange={(e) => setCedula(e.target.value.replace(/\D/g, ''))} />
                </div>
                <div>
                    <label>Tipo</label>
                    <select className="form-control" value={kind} onChange={(e) => setKind(e.target.value)}>
                        {KINDS.map((k) => <option key={k.id} value={k.id}>{k.label}</option>)}
                    </select>
                </div>
                <strong style={{ marginLeft: 'auto', color: 'var(--primary-color)' }}>
                    {total > rows.length ? `Mostrando ${rows.length} de ${total} movimientos` : `${total} movimiento(s)`}
                </strong>
            </div>

            {error && <p style={{ color: '#9b1c1c' }}>{error}</p>}
            {loading ? <p>Cargando…</p> : (
                <div style={{ overflowX: 'auto' }}>
                    <table className="table">
                        <thead>
                            <tr><th>Fecha</th><th>Tipo</th><th>Cliente</th><th>Cédula</th><th>Detalle</th><th>Puntos</th><th>Saldo</th><th>Registró</th></tr>
                        </thead>
                        <tbody>
                            {rows.length === 0 && !error && <tr><td colSpan="8">Sin movimientos con estos filtros.</td></tr>}
                            {rows.map((r) => {
                                const { label, background, color } = kindOf(r);
                                return (
                                    <tr key={r.id}>
                                        <td style={{ whiteSpace: 'nowrap' }}>{fmtDateTime(r.created_at)}</td>
                                        <td><span style={{ ...pillStyle, background, color }}>{label}</span></td>
                                        <td>{r.customer_name}</td>
                                        <td>{r.customer_cedula || '—'}</td>
                                        <td>{r.reason || '—'}</td>
                                        <td style={{ fontWeight: 700, color: r.points_change >= 0 ? '#1f6b45' : 'var(--primary-color)' }}>
                                            {r.points_change >= 0 ? '+' : ''}{r.points_change}
                                        </td>
                                        <td>{r.balance_after}</td>
                                        <td>{r.created_by || '—'}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default HistorialPuntos;
